import { toast } from "sonner";
import api, { apiError } from "./api";

export async function downloadDoc(doc) {
  try {
    const r = await api.get(`/documents/${doc.id}/download`, { responseType: "blob" });
    const ext = doc.storage_path ? "" : ".txt";
    const url = window.URL.createObjectURL(new Blob([r.data]));
    const a = document.createElement("a");
    a.href = url;
    a.download = doc.name.endsWith(".pdf") || doc.storage_path ? doc.name : `${doc.name}${ext}`;
    a.click();
    window.URL.revokeObjectURL(url);
    toast.success("Document downloaded");
  } catch (e) {
    toast.error(apiError(e));
  }
}

export async function downloadStatement(path, filename) {
  try {
    const r = await api.get(path, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    toast.success("Statement downloaded");
  } catch (e) {
    toast.error(apiError(e));
  }
}
